<template>
  <div class="container w" style="margin-top: 50px">
    <header>
      <h1>测评优选</h1>
      <p class="subtitle">
        通过8个维度的测评,全面分析您的军校报考倾向，为您提供科学的决策参考
      </p>
    </header>
    <!-- 分数查询部分 -->
    <div class="score-query-section">
      <el-card class="query-card">
        <template #header>
          <div class="card-header">
            <i class="fa fa-filter icon-primary"></i>
            <span>分数区间查询</span>
          </div>
        </template>

        <el-form :model="scoreForm" label-width="80px" class="query-form">
          <!-- 省份选择 -->
          <div class="form-group">
            <label class="form-label">省份</label>
            <el-select v-model="scoreForm.province" placeholder="请选择省份">
              <el-option
                v-for="item in provinces"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <!-- 年份选择 -->
          <div class="form-group">
            <label class="form-label">年份</label>
            <el-select v-model="scoreForm.year" placeholder="请选择年份">
              <el-option
                v-for="item in years"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <!-- 学科类别选择 -->
          <div class="form-group">
            <label class="form-label">学科类别</label>
            <el-select v-model="scoreForm.subject" placeholder="请选择学科类别">
              <el-option
                v-for="item in subjects"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <!-- 性别选择 -->
          <div class="form-group">
            <label class="form-label">性别</label>
            <el-select v-model="scoreForm.gender" placeholder="请选择性别">
              <el-option
                v-for="item in genders"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form>

        <!-- 分数输入 -->
        <div class="score-input-container">
          <el-form :model="scoreForm" label-width="80px" class="score-form">
            <div class="form-group">
              <label class="form-label">输入分数</label>
              <el-input
                v-model.number="scoreForm.score"
                placeholder="请输入您的分数"
                prefix-icon="el-icon-graduation-cap"
              >
                <template #append>分</template>
              </el-input>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>

    <!-- 测评优选部分 -->
    <div class="grid-container">
      <!-- 性格维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">⭐</span> 1. 性格倾向</div>
        <div class="description">
          <p>请根据您的性格特点选择倾向程度。</p>
        </div>
        <div class="slider-container">
          <el-slider
            v-model="dimensions.personality"
            :min="1"
            :max="5"
            :step="1"
            :marks="{
              1: '内向',
              3: '一般',
              5: '外向',
            }"
          ></el-slider>
          <!-- 随滑动条显示的动态变化字 -->
          <!-- <div class="slider-value">{{ personalityText }}</div> -->
        </div>
      </div>

      <!-- 个人意愿维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">🔥</span> 2. 个人意愿</div>
        <div class="description">
          <p>请根据您的报考意愿选择倾向程度。</p>
        </div>
        <div class="slider-container">
          <el-slider
            v-model="dimensions.motivation"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="{
              1: '非常不愿意',
              2: '比较不愿意',
              3: '一般',
              4: '比较愿意',
              5: '非常愿意',
            }"
          ></el-slider>
          <!-- <div class="slider-value">{{ motivationText }}</div> -->
        </div>
      </div>

      <!-- 家庭支持维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">👨‍👩‍👧‍👦</span> 3. 家庭支持</div>
        <div class="description">
          <p>家庭对您报考军校的支持程度，家人的态度对您的决策有重要影响。</p>
        </div>
        <div class="slider-container">
          <el-slider
            v-model="dimensions.familySupport"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="{
              1: '非常不支持',
              2: '比较不支持',
              3: '一般',
              4: '比较支持',
              5: '非常支持',
            }"
          ></el-slider>
          <!-- <div class="slider-value">{{ familySupportText }}</div> -->
        </div>
      </div>

      <!-- 地域维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">🌍</span> 4. 地域因素</div>
        <div class="description">
          <p>请选择您当前居住的地区以及您期望的报考院校所在地</p>
        </div>

        <div class="region-selectors">
          <div class="region-selector">
            <label>当前居住地：</label>
            <el-select
              v-model="dimensions.currentRegion"
              placeholder="请选择"
              class="region-select"
              @change="updateRegionAnalysis"
            >
              <el-option
                v-for="item in regionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>

          <div class="region-selector">
            <label>报考院校所在地：</label>
            <el-select
              v-model="dimensions.targetRegion"
              placeholder="请选择"
              class="region-select"
              @change="updateRegionAnalysis"
            >
              <el-option
                v-for="item in regionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>

        <div
          v-if="dimensions.currentRegion && dimensions.targetRegion"
          class="region-match"
        >
          <div class="match-indicator">
            <div class="match-text">地域匹配度：</div>
            <div class="match-value">{{ regionMatchPercentage }}%</div>
          </div>
          <el-progress
            :percentage="regionMatchPercentage"
            :color="matchColor"
            :stroke-width="12"
            :text-inside="true"
          />
          <div class="region-analysis">{{ regionAnalysis }}</div>
        </div>
      </div>

      <!-- 家庭背景 -->
      <div class="card">
        <div class="card-title"><span class="icon">🏠</span> 5. 家庭背景</div>
        <div class="description">
          <p>请选择父母职业</p>
        </div>
        <div class="slider-container">
          <!-- <el-slider
            v-model="dimensions.familyBackground"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="marks"
          ></el-slider>
          <div class="slider-value">{{ familyBackgroundText }}</div> -->
          <el-select
            v-model="dimensions.familyBackground"
            placeholder="请选择"
            class="region-select"
          >
            <el-option label="农村务农" value="farmer" />
            <el-option label="自由职业" value="freelancer" />
            <el-option label="军人" value="soldier" />
            <el-option label="企业人员" value="employee" />
            <el-option label="公务员" value="civilServant" />
          </el-select>
          <div class="slider-value">当前选择：{{ familyBackgroundText }}</div>
        </div>
      </div>

      <!-- 个人兴趣维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">❤️</span> 6. 个人兴趣</div>
        <div class="description">
          <p>请选择或填入您的个人爱好，特长</p>
        </div>
        <div class="slider-container">
          <!-- <el-slider
            v-model="dimensions.interest"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="marks"
          ></el-slider>
          <div class="slider-value">{{ interestText }}</div> -->
          <!-- 多选下拉框 -->
          <el-select
            v-model="dimensions.interests"
            placeholder="请选择"
            class="region-select"
            multiple
          >
            <template #tags="{ tags, handleClose, disabled }">
              <el-tag
                v-for="tag in tags"
                :key="tag"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
              >
                {{ tag }}
              </el-tag>
            </template>
            <el-option label="理科" value="general" />
            <el-option label="文科" value="liberal" />
            <el-option label="体育运动" value="sports" />
            <el-option label="音乐艺术" value="music arts" />
            <el-option label="美术" value="fine arts" />
            <el-option label="演讲" value="public speaking" />
          </el-select>

          <!-- 自定义输入框 -->
          <el-input
            v-model="dimensions.customInterest"
            placeholder="请输入其他兴趣"
            class="region-select"
            style="margin-top: 10px"
          />

          <!-- 显示选择结果 -->
          <div class="slider-value">
            当前选择：{{ interestText }}
            <span v-if="dimensions.customInterest" class="custom-interest"
              >, {{ dimensions.customInterest }}</span
            >
          </div>
        </div>
      </div>

      <!-- 前景展望维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">🚀</span> 7. 前景展望</div>
        <div class="description">
          <p>您对未来发展的期望：稳定晋升、跨行发展或拥有更多选择空间</p>
        </div>
        <div class="slider-container">
          <el-slider
            v-model="dimensions.prospect"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="{
              1: '更多选择',
              3: '跨行发展',
              5: '稳定晋升',
            }"
          ></el-slider>
          <!-- <div class="slider-value">{{ prospectText }}</div> -->
        </div>
      </div>

      <!-- "躺平"时光维度 -->
      <div class="card">
        <div class="card-title"><span class="icon">😌</span> 8. 纪律适应性</div>
        <div class="description">
          <p>您对自由生活的向往程度，军校生活相对严格规范，需考虑适应度</p>
        </div>
        <div class="slider-container">
          <el-slider
            v-model="dimensions.freedom"
            :min="1"
            :max="5"
            :step="1"
            show-stops
            :marks="{
              1: '非常不适应',
              2: '较难适应',
              3: '基本适应',
              4: '较好适应',
              5: '完全适应',
            }"
          ></el-slider>
          <!-- <div class="slider-value">{{ freedomText }}</div> -->
        </div>
      </div>
    </div>
    <!-- 生成测评报告按钮 -->
    <div class="btn-container">
      <button class="submit-btn" @click="generateReport">生成测评报告</button>
    </div>
    <!-- 分析报告模块 -->
    <div
      class="result-container"
      :style="{ display: showResult ? 'block' : 'none' }"
    >
      <h2 class="result-header">分数查询的检测报告</h2>
      <!-- 分数报告部分 -->
      <div v-if="scoreReportVisible" class="score-report-section">
        <h3 class="section-title">分数分析报告</h3>

        <div class="score-analysis">
          <div
            v-if="passMilitaryInspectionSchools.length > 0"
            class="school-list"
          >
            <h4>您的分数达到军检线的学校：</h4>
            <ul>
              <li
                v-for="school in passMilitaryInspectionSchools"
                :key="school.schoolname"
              >
                <div class="school-name">{{ school.schoolname }}</div>
                <div class="school-scores">
                  <span class="score-item">军检线: {{ school.score }}分</span>
                  <span class="score-item"
                    >录取区间: {{ school.minscore }}-{{
                      school.maxscore
                    }}分</span
                  >
                  <span class="score-item"
                    >平均分: {{ school.avgscore }}分</span
                  >
                  <!-- 添加排名位次区间 -->
                  <span class="score-item"
                    >排名位次: {{ school.minranking || "N/A" }} ~
                    {{ school.maxranking || "N/A" }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="no-data">您的分数未达到任何学校的军检线</div>

          <div v-if="passAdmissionSchools.length > 0" class="school-list">
            <h4>您的分数可选择的学校：</h4>
            <ul>
              <li
                v-for="school in passAdmissionSchools"
                :key="school.schoolname"
              >
                <div class="school-name">{{ school.schoolname }}</div>
                <div class="school-scores">
                  <span class="score-item"
                    >录取区间: {{ school.minscore }}-{{
                      school.maxscore
                    }}分</span
                  >
                  <span class="score-item"
                    >平均分: {{ school.avgscore }}分</span
                  >
                  <span class="score-item"
                    >最低分: {{ school.minscore }}分</span
                  >
                  <!-- 添加排名位次区间 -->
                  <span class="score-item"
                    >排名位次: {{ school.minranking || "N/A" }} ~
                    {{ school.maxranking || "N/A" }}</span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="no-data">您的分数未达到任何学校的录取最低分</div>
        </div>
      </div>
      <h2 class="result-header">测评优选的测评报告</h2>
      <!-- 原有测评报告部分 -->
      <div class="chart-container">
        <canvas id="radarChart"></canvas>
      </div>

      <!-- 维度分析结果 -->
      <!-- 性格倾向 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">⭐</span> 性格倾向
          <span class="dimension-score">{{ dimensions.personality }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (dimensions.personality / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ personalityAnalysis }}</p>
      </div>
      <!-- 个人意愿维度 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">🔥</span> 个人意愿
          <span class="dimension-score">{{ dimensions.motivation }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (dimensions.motivation / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ motivationAnalysis }}</p>
      </div>
      <!-- 家庭支持 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">👨‍👩‍👧‍👦</span> 家庭支持
          <span class="dimension-score">{{ dimensions.familySupport }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (dimensions.familySupport / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ familySupportAnalysis }}</p>
      </div>
      <!-- 地域因素 -->
      <!-- <div class="dimension-result">
        <h3 class="dimension-title"><span class="icon">🌍</span> 地域因素</h3> -->
      <!-- <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: dimensions.region + '%' }"
          ></div>
        </div> -->
      <!-- <p class="dimension-analysis">{{ regionAnalysis }}</p>
      </div> -->
      <!-- 家庭背景 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">🏠</span> 家庭背景
          <span class="dimension-score"
            >{{ familyBackgroundScoreValue }}分</span
          >
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (familyBackgroundScoreValue / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ familyBackgroundAnalysis }}</p>
      </div>
      <!-- 个人兴趣 -->
      <!-- <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">❤️</span> 个人兴趣
          <span class="dimension-score">{{ interestText }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: dimensions.interest + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ interestAnalysis }}</p>
      </div> -->
      <!-- 前景展望 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">🚀</span> 前景展望
          <span class="dimension-score">{{ dimensions.prospect }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (dimensions.prospect / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ prospectAnalysis }}</p>
      </div>
      <!-- 纪律适应性 -->
      <div class="dimension-result">
        <h3 class="dimension-title">
          <span class="icon">😌</span> 纪律适应性
          <span class="dimension-score">{{ dimensions.freedom }}分</span>
        </h3>
        <div class="progress-container">
          <div
            class="progress-bar"
            :style="{ width: (dimensions.freedom / 5) * 100 + '%' }"
          ></div>
        </div>
        <p class="dimension-analysis">{{ freedomAnalysis }}</p>
      </div>
      <!-- 综合评估部分 -->
      <div class="overall-result">
        <h3 class="overall-title">综合评估与建议</h3>
        <p class="overall-content">{{ overallAssessment }}</p>
        <!-- 添加院校推荐展示区域 -->
        <div v-if="recommendedSchools.length > 0" class="school-recommendation">
          <h3 class="recommendation-title">院校推荐</h3>
          <div class="recommendation-list">
            <div
              v-for="(school, index) in displayedSchools"
              :key="school"
              class="school-item"
            >
              {{ school }}
            </div>
          </div>
          <div
            v-if="recommendedSchools.length > 4"
            class="toggle-button"
            @click="toggleShowAll"
          >
            {{ showAll ? "收起" : "查看更多" }}
            <i
              :class="[
                'el-icon',
                showAll ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
              ]"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createApp, ref, computed, reactive } from "vue";
import { ElSlider, ElSelect, ElOption, ElProgress } from "element-plus";
import { Chart, registerables } from "chart.js"; // 导入图表
import axios from "axios"; //查分数导入
import { baseURL } from "@/api/axiosConfig";
// import Chart from "chart.js/dist/chart.umd.min";

// 注册所有 Chart.js 组件
Chart.register(...registerables);
export default {
  components: {
    ElSlider,
    ElSelect,
    ElOption,
    ElProgress,
  },
  setup() {
    // 查分数的相关方法

    // 添加分数查询相关数据
    const scoreForm = reactive({
      province: "河北省",
      year: "2024",
      subject: "物理",
      gender: "男生",
      score: null,
    });
    // 分数报告相关状态
    const scoreReportVisible = ref(false);
    const passMilitaryInspectionSchools = ref([]);
    const passAdmissionSchools = ref([]);
    // const schoolData = ref([]);

    // 分数查询选项
    const provinces = [
      { value: "hebei", label: "河北" },
      // 其他省份...
    ];
    //年份
    const years = [
      { value: "2024", label: "2024年" },
      { value: "2023", label: "2023年" },
      { value: "2022", label: "2022年" },
    ];
    //学科类别 (type)
    const subjects = [
      { value: "物理", label: "物理类" },
      { value: "历史", label: "历史类" },
    ];
    //性别 (sex)
    const genders = [
      { value: "男生", label: "男生" },
      { value: "女生", label: "女生" },
    ];

    // 获取学校数据
    const fetchSchoolData = async () => {
      try {
        const API_URL = baseURL + "/interface/searchscore/getSearchscore";
        const response = await axios.get(
          API_URL +
            "?year=" +
            scoreForm.year +
            "&&sex=" +
            scoreForm.gender +
            "&&type=" +
            scoreForm.subject
        );

        if (response.data && response.data.code === 200) {
          schoolData.value = response.data.data || [];
          analyzeScore();
          return true;
        }
      } catch (error) {
        console.error("获取学校数据失败:", error);
      }
      return false;
    };

    // 分析分数
    const analyzeScore = () => {
      if (!scoreForm.score || isNaN(scoreForm.score)) return;

      // 重置结果
      passMilitaryInspectionSchools.value = [];
      passAdmissionSchools.value = [];

      // 过滤有效学校数据
      const validSchools = schoolData.value.filter(
        (school) => school.score && school.minscore
      );

      validSchools.forEach((school) => {
        // 达到军检线
        if (scoreForm.score >= school.score) {
          passMilitaryInspectionSchools.value.push(school);
        }

        // 达到录取最低分
        if (scoreForm.score >= school.minscore) {
          passAdmissionSchools.value.push(school);
        }
      });

      // 按分数排序
      passMilitaryInspectionSchools.value.sort((a, b) => a.score - b.score);
      passAdmissionSchools.value.sort((a, b) => a.minscore - b.minscore);

      scoreReportVisible.value = true;
    };

    // 以下是测评优选部分
    const marks = {
      1: "内向",
      3: "一般",
      5: "外向",
    };
    // 添加显示控制
    const showAll = ref(false);
    const displayedSchools = computed(() => {
      return showAll.value
        ? recommendedSchools.value
        : recommendedSchools.value.slice(0, 4);
    });

    const toggleShowAll = () => {
      showAll.value = !showAll.value;
    };

    // 添加院校数据
    const schoolData = {
      // 按性格分类
      byPersonality: {
        extrovert: ["陆军步兵学院", "海军潜艇学院"], // 指挥类
        introvert: ["陆军工程大学"], // 非指挥类
      },
      // 按地域分类
      byRegion: {
        north: [
          "国防科技大学",
          "陆军防化学院",
          "海军大连舰艇学院",
          "海军潜艇学院",
          "海军航空大学",
          "空军航空大学",
          "空军工程大学",
          "空军军医大学",
          "火箭军工程大学",
          "军事航天部队航天工程大学",
          "武警工程大学",
          "网络空间部队信息工程大学",
        ],
        south: [
          "国防科技大学",
          "陆军工程大学",
          "陆军兵种类大学",
          "陆军步兵学院",
          "陆军军医大学",
          "海军工程大学",
          "海军军医大学",
          "空军预警学院",
          "信息支援部队工程大学",
          "联勤保障部队工程大学",
          "武警警官学院",
        ],
      },
    };

    // 省份区域映射 (南方/北方)
    const provinceRegionMap = {
      beijing: "north",
      tianjin: "north",
      hebei: "north",
      shanxi: "north",
      neimenggu: "north",
      liaoning: "north",
      jilin: "north",
      heilongjiang: "north",
      shanghai: "south",
      jiangsu: "south",
      zhejiang: "south",
      anhui: "south",
      fujian: "south",
      jiangxi: "south",
      shandong: "north", // 山东通常被视为北方
      henan: "north",
      hubei: "south",
      hunan: "south",
      guangdong: "south",
      guangxi: "south",
      hainan: "south",
      chongqing: "south",
      sichuan: "south",
      guizhou: "south",
      yunnan: "south",
      xizang: "south",
      shanxi1: "north",
      gansu: "north",
      qinghai: "north",
      ningxia: "north",
      xinjiang: "north",
    };
    // 地域选项 为具体省份
    const regionOptions = [
      { value: "beijing", label: "北京市" },
      { value: "tianjin", label: "天津市" },
      { value: "hebei", label: "河北省" },
      { value: "shanxi", label: "山西省" },
      { value: "neimenggu", label: "内蒙古自治区" },
      { value: "liaoning", label: "辽宁省" },
      { value: "jilin", label: "吉林省" },
      { value: "heilongjiang", label: "黑龙江省" },
      { value: "shanghai", label: "上海市" },
      { value: "jiangsu", label: "江苏省" },
      { value: "zhejiang", label: "浙江省" },
      { value: "anhui", label: "安徽省" },
      { value: "fujian", label: "福建省" },
      { value: "jiangxi", label: "江西省" },
      { value: "shandong", label: "山东省" },
      { value: "henan", label: "河南省" },
      { value: "hubei", label: "湖北省" },
      { value: "hunan", label: "湖南省" },
      { value: "guangdong", label: "广东省" },
      { value: "guangxi", label: "广西壮族自治区" },
      { value: "hainan", label: "海南省" },
      { value: "chongqing", label: "重庆市" },
      { value: "sichuan", label: "四川省" },
      { value: "guizhou", label: "贵州省" },
      { value: "yunnan", label: "云南省" },
      { value: "xizang", label: "西藏自治区" },
      { value: "shanxi1", label: "陕西省" },
      { value: "gansu", label: "甘肃省" },
      { value: "qinghai", label: "青海省" },
      { value: "ningxia", label: "宁夏回族自治区" },
      { value: "xinjiang", label: "新疆维吾尔自治区" },
    ];

    // 添加院校推荐列表
    const recommendedSchools = ref([]);
    // 省份所属区域分组映射
    const provinceToRegionMap = {
      beijing: "north",
      tianjin: "north",
      hebei: "north",
      shanxi: "north",
      neimenggu: "north",

      liaoning: "northeast",
      jilin: "northeast",
      heilongjiang: "northeast",

      shanghai: "east",
      jiangsu: "east",
      zhejiang: "east",
      anhui: "east",
      fujian: "east",
      jiangxi: "east",
      shandong: "east",

      henan: "central",
      hubei: "central",
      hunan: "central",

      guangdong: "south",
      guangxi: "south",
      hainan: "south",

      chongqing: "southwest",
      sichuan: "southwest",
      guizhou: "southwest",
      yunnan: "southwest",
      xizang: "southwest",

      shanxi1: "northwest",
      gansu: "northwest",
      qinghai: "northwest",
      ningxia: "northwest",
      xinjiang: "northwest",
    };
    const dimensions = ref({
      personality: 3,
      motivation: 3,
      familySupport: 3,
      // 移除原来的region属性
      // region: 3,
      familyBackground: "farmer", //父母职业默认务农
      interest: "sports",
      prospect: 3,
      freedom: 3,
      // 添加新的地域属性
      currentRegion: "", // 当前居住地
      targetRegion: "", // 目标院校地
      interests: [], // 多选兴趣
      customInterest: "", // 自定义兴趣
    });

    const showResult = ref(false);
    let radarChart = null;

    // 分析报告计算属性
    // 添加地域匹配度计算
    const regionMatchPercentage = ref(0);
    const regionAnalysis = ref("");
    const matchColor = ref("#67C23A");

    // 计算地域分数（用于综合评估）
    const regionScore = computed(() => {
      if (!dimensions.value.currentRegion || !dimensions.value.targetRegion)
        return 3;

      // 相同地区：5分（最高）
      if (dimensions.value.currentRegion === dimensions.value.targetRegion)
        return 5;

      // 相邻地区：4分
      if (
        isAdjacentRegion(
          dimensions.value.currentRegion,
          dimensions.value.targetRegion
        )
      )
        return 4;

      // 不同地区：3分（中等）
      return 3;
    });

    // 更新地域分析
    const updateRegionAnalysis = () => {
      if (!dimensions.value.currentRegion || !dimensions.value.targetRegion) {
        regionMatchPercentage.value = 0;
        regionAnalysis.value = "";
        return;
      }

      // 计算匹配度 (相同地区100%，相邻地区80%，其他60%)
      if (dimensions.value.currentRegion === dimensions.value.targetRegion) {
        regionMatchPercentage.value = 100;
        regionAnalysis.value =
          "您选择的院校所在地与您当前居住地相同，气候和生活习惯高度匹配，适应起来会更加容易。";
      } else if (
        isAdjacentRegion(
          dimensions.value.currentRegion,
          dimensions.value.targetRegion
        )
      ) {
        regionMatchPercentage.value = 80;
        regionAnalysis.value =
          "您选择的院校所在地与您当前居住地相邻，气候和生活习惯较为接近，适应难度适中。";
      } else {
        regionMatchPercentage.value = 60;
        regionAnalysis.value =
          "您选择的院校所在地与您当前居住地差异较大，可能需要更多时间适应气候和生活习惯的变化。";
      }

      // 根据匹配度设置颜色
      matchColor.value =
        regionMatchPercentage.value >= 80
          ? "#67C23A"
          : regionMatchPercentage.value >= 60
          ? "#E6A23C"
          : "#F56C6C";
    };
    // 判断两个省份是否属于相邻区域
    const isAdjacentRegion = (region1, region2) => {
      if (!region1 || !region2) return false;

      const getGroup = (province) => provinceToRegionMap[province] || "";

      const group1 = getGroup(region1);
      const group2 = getGroup(region2);

      // 定义区域间的相邻关系
      const adjacentGroups = {
        north: ["northeast", "northwest", "central"],
        northeast: ["north"],
        northwest: ["north", "central"],
        east: ["central", "south"],
        central: ["north", "south", "east", "west"],
        south: ["central", "east", "southwest"],
        southwest: ["south", "northwest"],
        northwest: ["southwest", "north"],
      };

      return group1 === group2 || adjacentGroups[group1]?.includes(group2);
    };
    //家庭背景
    const familyBackgroundScoreValue = computed(() => {
      const scoreMap = {
        farmer: 5, // 农村务农
        freelancer: 3, // 自由职业
        soldier: 1, // 军人
        employee: 1, // 企业人员
        civilServant: 1, // 公务员
      };
      return scoreMap[dimensions.value.familyBackground] || 1;
    });
    //家庭背景：展示用户选择的文本
    const familyBackgroundText = computed(() => {
      const map = {
        farmer: "农村务农",
        freelancer: "自由职业",
        soldier: "军人",
        employee: "企业人员",
        civilServant: "公务员",
      };
      return map[dimensions.value.familyBackground];
    });
    //个人兴趣的文本展示：当前选择的映射
    const interestMap = {
      general: "理科",
      liberal: "文科",
      sports: "体育运动",
      "music arts": "音乐艺术",
      "fine arts": "美术",
      "public speaking": "演讲",
    };
    const interestText = computed(() => {
      const selected = dimensions.value.interests
        .map((val) => interestMap[val] || val)
        .join("、");

      return selected ? selected : "未选择";
    });
    // 性格倾向
    const personalityText = computed(() => {
      if (dimensions.value.personality < 3) return "内向 ";
      if (dimensions.value.personality == 3) return "一般";
      return "外向";
    });
    //  个人意愿
    const motivationText = computed(() => {
      if (dimensions.value.motivation <= 1) return "非常不愿意";
      if (dimensions.value.motivation <= 2) return "比较愿意";
      if (dimensions.value.motivation <= 3) return "一般";
      if (dimensions.value.motivation <= 4) return "比较愿意";
      return "非常愿意";
    });
    // 家庭支持
    const familySupportText = computed(() => {
      if (dimensions.value.familySupport <= 1) return "非常不支持";
      if (dimensions.value.familySupport <= 2) return "比较不支持";
      if (dimensions.value.familySupport <= 3) return "一般";
      if (dimensions.value.familySupport <= 4) return "比较支持";
      return "非常支持";
    });
    //地域
    // const regionText = computed(() => {
    //   if (dimensions.value.region < 30) return "北方";
    //   if (dimensions.value.region < 70) return "无强烈偏好";
    //   return "南方";
    // });
    //家庭背景
    // const familyBackgroundText = computed(() => {
    //   if (dimensions.value.familyBackground < 5) return "农村务农";
    //   if (dimensions.value.familyBackground <= 3) return "自由职业";
    //   return "公务员/企业/军人";
    // });
    //个人兴趣
    // const interestText = computed(() => {
    //   if (dimensions.value.interest < 30) return "兴趣较低";
    //   if (dimensions.value.interest < 70) return "有一定兴趣";
    //   return "兴趣浓厚";
    // });
    //前景展望
    const prospectText = computed(() => {
      if (dimensions.value.prospect == 1) return "更多选择";
      if (dimensions.value.prospect == 3) return "跨行发展";
      if (dimensions.value.prospect == 5) return "稳定晋升";
      return ""; // 默认返回空字符串，或者可以根据需求返回其他默认值
    });
    //纪律适应性
    const freedomText = computed(() => {
      if (dimensions.value.freedom == 1) return "非常不适应";
      if (dimensions.value.freedom == 2) return "较难适应";
      if (dimensions.value.freedom == 3) return "基本适应";
      if (dimensions.value.freedom == 4) return "较好适应";
      return "完全适应";
    });

    // 分析报告
    const personalityAnalysis = computed(() => {
      if (dimensions.value.personality === 1)
        return "您的性格偏内向，适合技术研究、后勤保障等非指挥类岗位。这类岗位需要专注力和细致性，能发挥您的优势。";
      if (dimensions.value.personality === 2)
        return "您的性格较为均衡，既能适应指挥类岗位的团队协作要求，也能胜任非指挥类岗位的专业工作。";
      return "您的性格外向，具备领导潜质，适合军事指挥、政治工作等需要较强组织协调能力的岗位。";
    });

    const motivationAnalysis = computed(() => {
      if (dimensions.value.motivation < 30)
        return "您报考军校的动力不足，建议深入思考职业规划，明确个人目标后再做决定。";
      if (dimensions.value.motivation < 70)
        return "您对报考军校有一定动力，但仍有疑虑。建议深入了解军校生活和职业发展路径，增强报考信心。";
      return "您报考军校的动力很强，对军旅生涯有清晰认知和强烈向往，具备良好的心理准备。";
    });

    const familySupportAnalysis = computed(() => {
      if (dimensions.value.familySupport < 30)
        return "家庭支持度较低，这可能会成为您军旅生涯的阻力。建议与家人深入沟通，争取理解与支持。";
      if (dimensions.value.familySupport < 70)
        return "家庭对您的选择持中立态度。家人的理解和支持对长期服役很重要，建议加强沟通。";
      return "家庭非常支持您的选择，这将为您的军旅生涯提供坚实后盾和情感支持。";
    });

    // const regionAnalysis = computed(() => {
    //   if (dimensions.value.region < 30)
    //     return "您来自北方地区，适应北方军校的气候和环境可能更容易。";
    //   if (dimensions.value.region < 70)
    //     return "您对院校所在地没有特别偏好，适应能力强，可以灵活选择院校。";
    //   return "您来自南方地区，选择南方院校可能更容易适应气候和生活习惯。";
    // });

    const familyBackgroundAnalysis = computed(() => {
      if (dimensions.value.familyBackground < 33)
        return "农村家庭背景通常培养出吃苦耐劳的品质，这对适应军校严格管理非常有帮助。";
      if (dimensions.value.familyBackground < 66)
        return "自由职业家庭背景使您可能更习惯灵活的环境，需要时间适应军校的纪律要求。";
      return "体制内或军人家庭背景让您对军校生活有更多了解，更容易适应和融入。";
    });

    const interestAnalysis = computed(() => {
      if (dimensions.value.interest < 30)
        return "您对军事领域的兴趣较低，需要认真考虑是否适合军校生活。兴趣是最好的老师，缺乏兴趣可能导致学习动力不足。";
      if (dimensions.value.interest < 70)
        return "您对军事领域有一定兴趣，可以通过进一步了解增强热情。军校专业性强，持续的兴趣是坚持的动力。";
      return "您对军事领域有浓厚兴趣，这是您在军校学习和未来发展的强大动力。";
    });

    const prospectAnalysis = computed(() => {
      if (dimensions.value.prospect === 1)
        return "您希望未来有更多选择空间，适合选择综合性强、技能可迁移的专业院校。";
      if (dimensions.value.prospect === 3)
        return "您对跨行发展持开放态度，建议选择基础学科扎实、军民两用性强的专业。";
      if (dimensions.value.prospect === 5)
        return "您期望稳定的职业发展路径，适合选择培养方向明确的院校和专业。军校体系能提供清晰的晋升通道。";
      return ""; // 默认返回空字符串，或者可以根据需求返回其他默认值
      return "您希望未来有更多选择空间，适合选择综合性强、技能可迁移的专业院校。";
    });

    const freedomAnalysis = computed(() => {
      if (dimensions.value.freedom < 30)
        return "您特别向往自由，需要认真考虑是否能适应军校严格的纪律约束和集体生活。";
      if (dimensions.value.freedom < 70)
        return "您对自由有一定向往，但也能接受必要的纪律约束，适应军校生活需要时间调整。";
      return "您能较好地适应严格管理，具备在军校发展的心理素质。纪律性是军人必备的基本素质。";
    });

    // const overallAssessment = computed(() => {
    //   // 计算总分（排除兴趣维度）
    //   const totalScore =
    //     dimensions.value.personality * 1.2 +
    //     dimensions.value.motivation * 1.5 +
    //     dimensions.value.familySupport * 1.0 +
    //     regionScore.value * 0.8 + // 使用regionScore替代原来的dimensions.value.region
    //     familyBackgroundScore.value * 0.8 +
    //     dimensions.value.prospect * 1.0 +
    //     dimensions.value.freedom * 0.7;

    //   const maxScore = 5 * (1.2 + 1.5 + 1.0 + 0.8 + 0.8 + 1.0 + 0.7);
    //   const percentage = (totalScore / maxScore) * 100;

    //   if (percentage < 40) {
    //     return "综合评估：您报考军校的倾向较低。您的性格特点、自由向往度与军校要求匹配度不高，且个人意愿不足。建议您慎重考虑是否选择军校，或选择军民融合类院校作为过渡。";
    //   } else if (percentage < 70) {
    //     return "综合评估：您报考军校的倾向中等。您具备一定适应军校的素质，但在关键维度如个人意愿、纪律适应性方面仍有提升空间。建议您深入了解军校生活，加强相关素质培养后再做决定。";
    //   } else {
    //     return "综合评估：您报考军校的倾向很高！您的性格特点、个人意愿、适应能力等多个维度与军校要求高度匹配。建议您坚定报考信心，认真准备军校选拔考试，选择适合自己的专业方向。";
    //   }
    // });
    // 综合评估与建议
    const overallAssessment = computed(() => {
      // 条件1: 家庭支持+个人意愿<=4
      const condition1 =
        dimensions.value.familySupport + dimensions.value.motivation <= 4;
      // 条件2: 纪律适应性<=2
      const condition2 = dimensions.value.freedom <= 2;

      if (condition1 || condition2) {
        let reason = "";
        if (condition1) reason += "家庭支持和个人意愿较低";
        if (condition2) {
          if (reason) reason += "，且";
          reason += "纪律适应性不足";
        }
        return `综合评估：您目前不适合报考军校。原因：${reason}。建议加强相关方面的准备后再考虑报考。`;
      }
      // 清空之前的推荐
      recommendedSchools.value = [];

      // 适合报考的情况
      // let recommendation = "综合评估：您非常适合报考军校！";
      // 1. 根据性格推荐
      let personalitySchools = [];
      if (dimensions.value.personality >= 4) {
        personalitySchools = schoolData.byPersonality.extrovert;
      } else if (dimensions.value.personality <= 2) {
        personalitySchools = schoolData.byPersonality.introvert;
      }

      // 2. 根据地域推荐院校
      let regionSchools = [];
      if (dimensions.value.currentRegion) {
        const region =
          provinceRegionMap[dimensions.value.currentRegion] || "south";
        regionSchools = schoolData.byRegion[region];
      }
      // 合并推荐结果并去重
      const combined = [...new Set([...personalitySchools, ...regionSchools])];
      recommendedSchools.value = combined;

      // 构建评估文本 - 不再显示"指挥类"或"非指挥类"
      let assessment = "综合评估：您非常适合报考军校！";

      if (personalitySchools.length > 0) {
        assessment += ` 根据您的性格特点（${personalityText.value}），推荐相关院校。`;
      }

      // if (regionSchools.length > 0 && dimensions.value.currentRegion) {
      //   const regionName =
      //     regionOptions.find((r) => r.value === dimensions.value.currentRegion)
      //       ?.label || "当前地区";
      //   assessment += ` 根据您所在地区（${regionName}），推荐报考${
      //     provinceRegionMap[dimensions.value.currentRegion] === "north"
      //       ? "北方"
      //       : "南方"
      //   }院校。`;
      // }
      if (regionSchools.length > 0 && dimensions.value.currentRegion) {
        const regionName =
          regionOptions.find((r) => r.value === dimensions.value.currentRegion)
            ?.label || "当前地区";
        assessment += `推荐相关院校。`;
      }
      return assessment;
    });

    // 根据省份获取推荐军校
    const getMilitarySchoolByRegion = (region) => {
      const map = {
        beijing: "航天工程大学",
        shanghai: "海军医科大学",
        guangdong: "陆军特种作战学院",
      };
      return map[region] || "该地区知名军事院校";
    };
    // 生成报告函数
    // const generateReport = () => {
    //   showResult.value = true;
    //   setTimeout(renderRadarChart, 100);
    //   document
    //     .querySelector(".result-container")
    //     .scrollIntoView({ behavior: "smooth" });
    // };
    const generateReport = async () => {
      // 原有测评报告生成逻辑...
      showResult.value = true;
      setTimeout(renderRadarChart, 100);

      // 如果用户输入了分数，则生成分数报告
      if (scoreForm.score && !isNaN(scoreForm.score)) {
        await fetchSchoolData();
      }

      document
        .querySelector(".result-container")
        .scrollIntoView({ behavior: "smooth" });
    };
    // 雷达图渲染函数
    const renderRadarChart = () => {
      const ctx = document.getElementById("radarChart").getContext("2d");
      if (radarChart) radarChart.destroy();

      // 修改为
      radarChart = new Chart(ctx, {
        type: "radar",
        data: {
          labels: [
            "性格倾向",
            "个人意愿",
            "家庭支持",
            "家庭背景",
            "前景展望",
            "纪律适应性",
          ],
          datasets: [
            {
              label: "维度得分",
              data: [
                dimensions.value.personality,
                dimensions.value.motivation,
                dimensions.value.familySupport,
                familyBackgroundScoreValue.value, // ✅ 使用已定义的计算属性
                // dimensions.value.familyBackground,
                dimensions.value.prospect,
                dimensions.value.freedom,
              ],
              backgroundColor: "rgba(255, 140, 0, 0.2)",
              borderColor: "rgba(255, 99, 71, 1)", // 更鲜明的橙色
              pointBackgroundColor: "rgba(255, 99, 71, 1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(255, 99, 71, 1)",
              borderWidth: 3, // 增加这行代码，设置线条宽度为 3（可以根据需要调整数值）
              pointRadius: 5, // 增大点的大小
              pointHoverRadius: 7, // 增大悬停时点的大小
            },
          ],
        },
        options: {
          scales: {
            r: {
              angleLines: {
                color: "rgba(0, 0, 0, 0.3)", // 更深的网格线
              },
              grid: {
                color: "rgba(0, 0, 0, 0.2)", // 更深的网格线
              },
              pointLabels: {
                color: "#333", // 更深的字体颜色
                font: {
                  size: 14,
                  weight: "bold", // 加粗字体
                  family: "'Microsoft YaHei', sans-serif", // 指定字体
                },
              },
              ticks: {
                display: true, // 显示刻度
                stepSize: 1,
                backdropColor: "transparent",
                color: "#555", // 更深的刻度颜色
                font: {
                  size: 12,
                },
                z: 1, // 确保刻度显示在顶层
              },
              suggestedMin: 0,
              suggestedMax: 5,
            },
          },
          plugins: {
            legend: {
              labels: {
                color: "#333", // 更深的图例颜色
                font: {
                  size: 14,
                  weight: "bold",
                },
              },
            },
          },
          elements: {
            line: {
              tension: 0.1, // 减少曲线张力，使线条更直
              borderWidth: 3, // 确保线条足够粗
            },
          },
        },
      });
    };
    // 地域维度结果展示
    const regionAnalysisResult = computed(() => {
      if (!dimensions.value.currentRegion || !dimensions.value.targetRegion) {
        return "请完成地域选择";
      }

      return `您当前居住在${getRegionLabel(
        dimensions.value.currentRegion
      )}，计划报考${getRegionLabel(dimensions.value.targetRegion)}院校。${
        regionAnalysis.value
      }`;
    });

    const getRegionLabel = (value) => {
      const region = regionOptions.find((r) => r.value === value);
      return region ? region.label : "未知地区";
    };
    return {
      // 省略返回属性...（与原代码一致）
      familyBackgroundScoreValue, // 确保这里返回了 familyBackgroundScoreValue
      marks,
      dimensions,
      showResult,
      personalityText,
      motivationText,
      familySupportText,
      // regionText,
      familyBackgroundText,
      interestText, // 返回新的计算属性
      prospectText,
      freedomText,
      personalityAnalysis,
      motivationAnalysis,
      familySupportAnalysis,
      regionAnalysis,
      familyBackgroundAnalysis,
      interestAnalysis,
      prospectAnalysis,
      freedomAnalysis,
      overallAssessment,
      generateReport,
      // ...其他返回属性保持不变...
      regionOptions,
      regionMatchPercentage,
      regionAnalysis: regionAnalysisResult,
      matchColor,
      updateRegionAnalysis,
      regionScore,
      // 在报告部分使用regionScore
      regionAnalysisResult: computed(() => regionAnalysisResult.value),
      regionScoreForDisplay: computed(() => regionScore.value),
      recommendedSchools,
      displayedSchools,
      showAll,
      toggleShowAll,
      // 添加分数相关数据
      scoreForm,
      provinces,
      years,
      subjects,
      genders,
      scoreReportVisible,
      passMilitaryInspectionSchools,
      passAdmissionSchools,
      generateReport,
    };
  },
};
</script>

<!-- <style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}
/* 
body {
  background: linear-gradient(135deg, #0d1b2a, #1b263b);
  color: #fff;
  min-height: 100vh;
  padding: 20px;
} */

/* 省略重复样式...（与原代码一致） */

.dimension-result:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
  }

  h1 {
    font-size: 2rem;
  }
}
</style> -->
<style scoped>
.w {
  width: 1200px;
  margin: auto;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}

/* body {
  background: linear-gradient(135deg, #0d1b2a, #1b263b);
  color: #fff;
  min-height: 100vh;
  padding: 20px;
} */

.container {
  max-width: 1200px;
  margin: 0 auto;
  background-color: white;
}

header {
  text-align: center;
  padding: 30px 0;
  margin-bottom: 30px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  /* text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5); */
  background: linear-gradient(to right, #ffd700, #ff8c00);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 1.1rem;
  opacity: 0.8;
  max-width: 800px;
  margin: 0 auto;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.card {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
  background: rgba(255, 255, 255, 0.12);
}

.card-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 1.3rem;
  color: blue;
}

.card-title .icon {
  margin-right: 10px;
  font-size: 1.5rem;
}

.description {
  margin-bottom: 20px;
  line-height: 1.6;
  color: black;
}

.slider-container {
  padding: 0 15px;
}

.slider-value {
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
  font-weight: bold;
  color: #4dabf7;
}

.btn-container {
  text-align: center;
  margin: 40px 0;
}

.submit-btn {
  padding: 15px 50px;
  font-size: 1.2rem;
  background: linear-gradient(to right, #ff8c00, #ff5252);
  border: none;
  border-radius: 50px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(255, 140, 0, 0.4);
}

.submit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(255, 140, 0, 0.6);
}

.submit-btn:active {
  transform: translateY(1px);
}

.result-container {
  /* background: rgba(0, 0, 0, 0.4); */
  background-color: white;
  border-radius: 15px;
  padding: 30px;
  margin-top: 40px;
  display: none;
}

.result-header {
  text-align: center;
  margin-bottom: 30px;
  color: blue;
}

.chart-container {
  height: 300px;
  margin: 30px 0;
}

.dimension-result {
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
}

.dimension-title {
  color: #4dabf7;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.dimension-title .icon {
  margin-right: 10px;
}

.progress-container {
  height: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  margin: 15px 0;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  border-radius: 10px;
  background: linear-gradient(to right, #4facfe, #00f2fe);
  transition: width 1s ease;
}

.dimension-analysis {
  line-height: 1.7;
  color: black;
}

.overall-result {
  background: rgba(0, 0, 0, 0.3);
  padding: 25px;
  border-radius: 12px;
  margin-top: 30px;
  border-left: 4px solid #ff8c00;
}

.overall-title {
  color: #ffd700;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.overall-content {
  line-height: 1.8;
  font-size: 1.1rem;
  color: white;
}

.dimension-score {
  float: right;
  background: rgba(255, 215, 0, 0.2);
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: bold;
}

.dimension-result:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
  }

  h1 {
    font-size: 2rem;
  }
}
/* 地域因素 */
.region-selectors {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.region-selector {
  display: flex;
  align-items: center;
}

.region-selector label {
  min-width: 120px;
  color: #333;
  font-weight: bold;
}

.region-select {
  flex: 1;
}

.region-match {
  margin-top: 20px;
  padding: 15px;
  background: rgba(240, 248, 255, 0.7);
  border-radius: 8px;
}

.match-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.match-text {
  font-weight: bold;
  color: #333;
}

.match-value {
  margin-left: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  color: #409eff;
}

.region-analysis {
  margin-top: 15px;
  color: #555;
  line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .region-selectors {
    gap: 10px;
  }

  .region-selector {
    flex-direction: column;
    align-items: flex-start;
  }

  .region-selector label {
    margin-bottom: 5px;
  }

  .region-select {
    width: 100%;
  }
}

/* 在报告部分添加样式 */
.dimension-result .region-analysis {
  color: white;
  line-height: 1.6;
}
/* 兴趣维度中的自定义兴趣 */
.custom-interest {
  color: #f56c6c;
  font-weight: bold;
}

/* 添加院校推荐样式 */
.school-recommendation {
  margin-top: 20px;
  padding: 15px;
  background: rgba(240, 248, 255, 0.7);
  border-radius: 8px;
}

.recommendation-title {
  color: #409eff;
  margin-bottom: 10px;
  font-size: 1.2rem;
}

.recommendation-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.school-item {
  padding: 8px 12px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 0.9rem;
}

.toggle-button {
  margin-top: 15px;
  text-align: center;
  color: #409eff;
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.toggle-button:hover {
  text-decoration: underline;
}
/* 修复雷达图容器样式 */
.chart-container {
  height: 400px; /* 增加高度 */
  width: 100%;
  margin: 30px 0;
  position: relative;
  background: white; /* 确保背景为白色 */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* 确保雷达图在白色背景下可读 */
.result-container {
  background-color: white;
  color: #333; /* 深色文字 */
}

.dimension-title,
.dimension-analysis,
.overall-title,
.overall-content {
  color: #333; /* 深色文字 */
}

/* 进度条背景调整为更可见 */
.progress-container {
  background: rgba(0, 0, 0, 0.1);
}

/* 维度标题颜色调整 */
.dimension-title {
  color: #409eff; /* 使用element蓝色 */
}
</style>
<!-- 分数查询的样式 -->
<style scoped>
/* 新增分数查询样式 */
.score-query-section {
  margin-bottom: 30px;
}

.query-card {
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #165dff;
}

.query-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  margin-bottom: 5px;
  color: #606266;
}

.score-input-container {
  margin-top: 15px;
}

/* 分数报告样式 */
.score-report-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #165dff;
}

.section-title {
  color: #165dff;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.school-list {
  margin-bottom: 20px;
}

.school-list h4 {
  color: red;
  margin-bottom: 10px;
}

.school-list ul {
  padding-left: 20px;
}

.school-list li {
  margin-bottom: 8px;
  padding: 8px 12px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.no-data {
  padding: 15px;
  text-align: center;
  color: #f56c6c;
  background: #fff;
  border-radius: 4px;
}
/* 新增学校信息样式 */
.school-name {
  font-weight: bold;
  margin-bottom: 5px;
  color: #165dff;
}

.school-scores {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 5px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
}

.score-item {
  padding: 5px 10px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 180px;
}
</style>
